export default __webpack_public_path__ + "static/media/dp4dr8.3a78dc7f.npz";